 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		66: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		66: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gallery-overlay~medi~bd43bb1c","4":"buybox~stylequiz~super-sku","5":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~buybox","10":"add-to-list-drawer~magic-apron","11":"bath-renovation~orange-lens","12":"buybox~promotion-products-lazy","13":"compare~stylequiz","14":"promotion-products-lazy~quick-view","15":"ratings-and-reviews-mobile","16":"StoreLayout","17":"add-to-list-drawer","18":"aisle-bay","19":"augmented-reality","20":"bath-renovation","21":"breadcrumbs","22":"browse-and-search","23":"browse-and-search-mobile","24":"buybox","25":"calculator-pipcalculator","26":"collections","27":"collections-mobile","28":"common","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"emt-questions-and-answers-component","36":"fbr","37":"global-custom-configurator","38":"hammerjs","40":"home","41":"magic-apron","42":"measurement-guide","43":"measurement-guide-overlay-content","44":"media-gallery-filmstrip-mobile","45":"media-gallery-overlay","46":"media-gallery-overlay-mobile","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"ratings-and-reviews-desktop","64":"results","65":"returns-messaging","67":"share-to-email-overlay","68":"share-to-pinterest-overlay","69":"size-guide-overlay","70":"specifications","71":"stylequiz","72":"super-sku","73":"vendor-collection-products","74":"vendor-collections","75":"vendor-collections-mobile","77":"video-player","78":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"92333c3cc21c21e66dd8","1":"66ba34bc9e48a853bfbb","2":"5eaf298e679c99a6d181","3":"d822f31290e0fafd14a4","4":"eeffeb5521276e726c31","5":"e3f797d933764c02a52a","6":"9756b605ebc3113ed18f","7":"7cb17c210164b2b9bd00","8":"ab5a396ab9f389b745ec","9":"9f66bf5ff83ddb8f8b17","10":"65369e9c1335bf5c99ae","11":"f9920a7f5c2e620e370d","12":"264eac3b60e49946d3bf","13":"314c88253d6f3e557716","14":"2193be3247eff3541078","15":"c569838aa84ad9b5bd02","16":"6154f22d2d8321c9cf36","17":"da0294d0298160d6bf9c","18":"d5d4f652d0f06ef6ad9e","19":"c95502ff793afb2e92be","20":"92408739abde0044babc","21":"1db7f41b0f88961780e1","22":"4b2c78859d9b907fff2e","23":"546c3391fc38483bbdac","24":"c11652f491c88097e7ac","25":"c0ae770f8842f29f839e","26":"9fb2e3deef787fc941d0","27":"9bfb5d39070e3384415c","28":"e50e57d27ad10e5cf425","29":"3f445e382ea59489e71a","30":"5815c85d5a1732ec4887","31":"e59734577699744219be","32":"cbd3039715899a3f295c","33":"e82cb0272f0e4143a702","34":"ae9e3605866cae14188b","35":"7c2b22b95639d61ced32","36":"fcf497079d7f457d4a9c","37":"9497ff3b11da9159aa77","38":"638e2bd4dfb728c32121","40":"6197932d7890e8519792","41":"83c263a60dc6a7de7052","42":"4151afaa77c98cc145b8","43":"101cc04374a23c64030e","44":"fab201856fa11d2e4ad5","45":"d10fb1a7fdf5bdb3bdd1","46":"de66d03b4581f0d26683","47":"fc647681ffbe72efef60","48":"bcd07e110ada230972cd","49":"42bb1184efa0a6891122","50":"a60edbd2579cc4b697f9","51":"becfbb89aec2f4b35bfe","52":"3b7b0242b72587d48076","53":"d0f7ba19609f5ab88fc4","54":"4097bb04e106a2bb2302","55":"9b5ae8752a001e13eb41","56":"c98a34002af965cba0c6","57":"98961ee98cfd6e7a4ebd","58":"b6a2158089c84beda58a","59":"9c381de5d47a2788d972","60":"eaeff76f3bef298c6766","61":"9b0c8e32a0ce964420a0","62":"72930d1aa9253aeb609e","63":"c3581dcdbaa08db6c07c","64":"69618eef45c8e1e63259","65":"94818b56c1178eab968d","67":"fe8b81488703d983ab53","68":"bf579cb268b35e1e5c1e","69":"9b5e8f9419f952ce691b","70":"2d2423d35ee205e1a7b8","71":"0030d5d940c928a3f158","72":"6565bf57af5c39aa75e1","73":"99069b175b3b431e4682","74":"73260f4ddbe8f31942b1","75":"2bdfaf85e96dfd5fd519","77":"cdef8e74c93aa1378566","78":"9033ac8a547e9e9196ac","79":"d2f0b7ba436f5fdc78cf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"13":1,"14":1,"15":1,"18":1,"22":1,"23":1,"24":1,"26":1,"27":1,"29":1,"30":1,"31":1,"32":1,"33":1,"36":1,"37":1,"41":1,"44":1,"45":1,"46":1,"47":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"60":1,"61":1,"62":1,"69":1,"71":1,"72":1,"73":1,"74":1,"75":1,"77":1,"78":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gallery-overlay~medi~bd43bb1c","4":"buybox~stylequiz~super-sku","5":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~buybox","10":"add-to-list-drawer~magic-apron","11":"bath-renovation~orange-lens","12":"buybox~promotion-products-lazy","13":"compare~stylequiz","14":"promotion-products-lazy~quick-view","15":"ratings-and-reviews-mobile","16":"StoreLayout","17":"add-to-list-drawer","18":"aisle-bay","19":"augmented-reality","20":"bath-renovation","21":"breadcrumbs","22":"browse-and-search","23":"browse-and-search-mobile","24":"buybox","25":"calculator-pipcalculator","26":"collections","27":"collections-mobile","28":"common","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"emt-questions-and-answers-component","36":"fbr","37":"global-custom-configurator","38":"hammerjs","40":"home","41":"magic-apron","42":"measurement-guide","43":"measurement-guide-overlay-content","44":"media-gallery-filmstrip-mobile","45":"media-gallery-overlay","46":"media-gallery-overlay-mobile","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"ratings-and-reviews-desktop","64":"results","65":"returns-messaging","67":"share-to-email-overlay","68":"share-to-pinterest-overlay","69":"size-guide-overlay","70":"specifications","71":"stylequiz","72":"super-sku","73":"vendor-collection-products","74":"vendor-collections","75":"vendor-collections-mobile","77":"video-player","78":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2134e3f2525f4b18b82f","2":"31d6cfe0d16ae931b73c","3":"dc0bc626ca15ffc94f61","4":"20f2aced33e6b1ed7b41","5":"0ef658ad0521bc70e648","6":"fc13927f2b1da7e66c1b","7":"50d430c72ccc3cf96a34","8":"65f1d7aedc445dc5836f","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"ae101fda583e7f2b6c7f","14":"c076939ce172db5a3cb1","15":"2ade42f7647d0b013747","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"d94b956aa532c1a50c65","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"42652601ff0ae779858b","23":"766c85efdd2e5fc7d70f","24":"2bb695512c61ba30c420","25":"31d6cfe0d16ae931b73c","26":"6989b885c3a130631311","27":"245583dfb4167de3132b","28":"31d6cfe0d16ae931b73c","29":"69786068a57cedc624d3","30":"b71f8ffaebe49e5b8650","31":"32b2ceba1e4cfc936c08","32":"fc73174b407ad863c497","33":"b49004ddac99adec2224","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"88e24c7aafcf93ae6cc6","37":"1a5562a08d12f7682989","38":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"4be99b2862037eff2a09","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"e07956ac4ef9facbea2e","45":"ef0ca94c8b32dda1c4b9","46":"eb36f51d51b0383b84de","47":"89d9163eeb30e835d559","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"8c6f81079d68ffdbdf61","51":"fc650b263badee2304d6","52":"cff893f31bdad17e93fc","53":"745a3c4f0d536aa13161","54":"5163fb2f93ed403c3fdf","55":"d49dde70d4d938c3a911","56":"fddebf8003705aefed41","57":"be155bb5d11dacdc4bb8","58":"ee58265e369789fb3e9c","59":"31d6cfe0d16ae931b73c","60":"d70c859b20e57c1599c5","61":"6b1e71cf5a3b177302cf","62":"9d02d79dc9b8f52f7762","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"453dfc2640779a848cc6","70":"31d6cfe0d16ae931b73c","71":"d5a62d0aa3a631dae3cb","72":"b31101625f385d3bcc30","73":"e518e335254638969e62","74":"96acad5d779f9ce0b6c5","75":"760fc5b79894c2224a24","77":"24ab350a8a93783bfec6","78":"8fa58144c65ae4d5868b","79":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
